/**
 * @generated SignedSource<<bc1ab26c31c8995eb06e7b65c4ac0648>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetTaskSingleGroupingMode = "SECTION" | "TEAM";
export type WidgetTaskSingleSize = "ONE_X_ONE" | "TWO_X_ONE";
export type CreateWidgetTaskSingleInput = {
  grouping?: WidgetTaskSingleGroupingMode | null;
  positionX: number;
  positionY: number;
  sectionIds?: ReadonlyArray<string> | null;
  size: WidgetTaskSingleSize;
  taskId: string;
  teamIds?: ReadonlyArray<string> | null;
  title?: string | null;
};
export type WATaskSingleSizePreviewMutation$variables = {
  input: CreateWidgetTaskSingleInput;
  storecastId: string;
};
export type WATaskSingleSizePreviewMutation$data = {
  readonly dashboard: {
    readonly createWidgetTaskSingle: {
      readonly id: string;
    };
  };
};
export type WATaskSingleSizePreviewMutation = {
  response: WATaskSingleSizePreviewMutation$data;
  variables: WATaskSingleSizePreviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetTaskSingle",
        "kind": "LinkedField",
        "name": "createWidgetTaskSingle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WATaskSingleSizePreviewMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WATaskSingleSizePreviewMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "9d33b78c498ba8a6cf87ab4d47827b0c",
    "id": null,
    "metadata": {},
    "name": "WATaskSingleSizePreviewMutation",
    "operationKind": "mutation",
    "text": "mutation WATaskSingleSizePreviewMutation(\n  $storecastId: ID!\n  $input: CreateWidgetTaskSingleInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetTaskSingle(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a7d20810c51218ddbfde1518e8719f0e";

export default node;
